module.exports = __webpack_public_path__ + "img/04_LATA.a5a8aa5a.png";